import { Recorder, initialState, RecorderStatus } from './recorder.state';
import { RecorderActions, RecorderActionType } from './recorder.actions';

// models
import { RecordingConfig } from '@core/models/recording-config.model';

// import * as Objects from '@core/objects';

export function recorderReducer(state = initialState, action: RecorderActions): Recorder {
    switch (action.type) {

        case RecorderActionType.Init:
            return {...state,
                status: RecorderStatus.STARTING,
                notificationData: action.data
            }

        case RecorderActionType.Start:
            return {...state, 
                status: action.record.config.selectedCamId == "" ? RecorderStatus.STARTED_SCREEN_ONLY : RecorderStatus.STARTED,
                recordData: action.record
            }
        case RecorderActionType.StartSuccess:
            return {...state, 
                status: action.record.config.selectedCamId == "" ? RecorderStatus.RECORDING_SCREEN_ONLY : RecorderStatus.RECORDING,
                mediaRecorder: action.mediaRecorder
            }
        case RecorderActionType.StartFail:
            return {...state, ...initialState,
                status: RecorderStatus.FAILED
            }
        case RecorderActionType.Stop:
            return {...state, 
                status: RecorderStatus.STOPPED,        
            }
        case RecorderActionType.StoreStreamChunk:
            return {...state, 
                streamChunks: [...state.streamChunks, ...[action.chunk]] 
            }
        case RecorderActionType.Clear:
            return {...state, ...initialState}
        case RecorderActionType.Finish:
            return {...state, 
                status: action.success ? RecorderStatus.FINISHED_SUCCESS : RecorderStatus.FINISHED_ERROR
            }

        default:
	        return state;
    }
}
